// Faiz hesaplama motoru (ortak).
// Hem Hesap Detayı hem İcra Hesap ekranı bu mantığı kullanır.

// Yasal faiz (kanuni faiz) oranları — 3095 sayılı Kanun md.1
//
// TARİHSEL DÖNEM (16.07.2026 öncesi): oran, Bakanlar Kurulu /
// Cumhurbaşkanı kararlarıyla tek tek belirleniyordu. Bu dilimler
// sabittir ve değişmez.
export const YASAL_FAIZ_TARIHSEL = [
  { baslangic: '1984-12-19', oran: 30 },
  { baslangic: '1998-01-01', oran: 50 },
  { baslangic: '2000-01-01', oran: 60 },
  { baslangic: '2002-07-01', oran: 55 },
  { baslangic: '2003-07-01', oran: 50 },
  { baslangic: '2004-01-01', oran: 43 },
  { baslangic: '2005-05-01', oran: 12 },
  { baslangic: '2006-01-01', oran: 9 },
  { baslangic: '2024-06-01', oran: 24 },
].map((r) => ({ oran: r.oran, baslangic: new Date(r.baslangic + 'T00:00:00Z') }));

// 7589 sayılı Kanun ile değişik 3095 m.1 uyarınca kanuni faiz artık
// sabit bir oran DEĞİL; TCMB reeskont oranından türetiliyor ve her yıl
// kendiliğinden güncelleniyor. Yeni rejimin ilk uygulandığı tarih:
export const YASAL_FAIZ_YENI_REJIM_BASLANGIC = new Date('2026-07-31T00:00:00Z');

/** Sıralı bir oran tablosunda, verilen tarihte yürürlükteki oran. */
const oranAtDate = (rates, d) => {
  let oran = null;
  for (const r of rates) {
    if (r.baslangic.getTime() <= d.getTime()) oran = r.oran;
    else break;
  }
  return oran;
};

const round2 = (n) => Math.round(n * 100) / 100;

/**
 * 3095 m.1 (7589 s.K. ile değişik) — kanuni faiz dönemlerini üretir:
 *
 *   • Yıl Y için oran = önceki yılın 31 Aralık günü yürürlükteki
 *     TCMB kısa vadeli reeskont oranının %80'i.
 *   • 30 Haziran günü yürürlükteki reeskont oranı, önceki 31 Aralık
 *     oranından 5 PUAN veya daha fazla farklıysa, yılın ikinci
 *     yarısında (1 Temmuz'dan itibaren) o oranın %80'i uygulanır.
 *
 * Doğrulama: 31.12.2025 reeskont %38,75 → %80'i = %31 → 31.07.2026
 * itibarıyla yürürlükteki kanuni faiz. Resmî değerle birebir uyuşuyor.
 *
 * NOT: Üretim REESKONT_FAIZ_TABLOSU'na dayanır. Artık yasal faizi elle
 * güncellemek gerekmez; TCMB reeskont tablosunu güncel tutmak yeterlidir.
 */
export function uretYasalFaizDonemleri(sonYil) {
  const ilkYil = YASAL_FAIZ_YENI_REJIM_BASLANGIC.getUTCFullYear();
  const bitis = Math.max(ilkYil, Number(sonYil) || ilkYil);
  const out = [];

  for (let y = ilkYil; y <= bitis; y += 1) {
    const aralik31 = new Date(Date.UTC(y - 1, 11, 31));
    const reeskontAralik = oranAtDate(REESKONT_FAIZ_TABLOSU, aralik31);
    // Önceki yılın 31 Aralık oranı bilinmiyorsa o yıl üretilemez.
    if (reeskontAralik == null) continue;

    const yilBasi = y === ilkYil
      ? YASAL_FAIZ_YENI_REJIM_BASLANGIC
      : new Date(Date.UTC(y, 0, 1));

    out.push({
      baslangic: yilBasi,
      oran: round2(reeskontAralik * 0.8),
      kaynak: `%80 × ${reeskontAralik} (31.12.${y - 1} reeskont)`,
    });

    // Yıl ortası düzeltmesi: 30 Haziran farkı ≥ 5 puan ise
    const haziran30 = new Date(Date.UTC(y, 5, 30));
    const reeskontHaziran = oranAtDate(REESKONT_FAIZ_TABLOSU, haziran30);
    if (reeskontHaziran != null && Math.abs(reeskontHaziran - reeskontAralik) >= 5) {
      const temmuz1 = new Date(Date.UTC(y, 6, 1));
      // Yeni rejimin ilk yılında başlangıç zaten 31 Temmuz; geriye gidilmez.
      if (temmuz1.getTime() > yilBasi.getTime()) {
        out.push({
          baslangic: temmuz1,
          oran: round2(reeskontHaziran * 0.8),
          kaynak: `%80 × ${reeskontHaziran} (30.06.${y} reeskont — 5 puan kuralı)`,
        });
      }
    }
  }
  return out;
}

// NOT: YASAL_FAIZ_TABLOSU, REESKONT_FAIZ_TABLOSU'ndan türetildiği için
// o tablonun TANIMINDAN SONRA oluşturulur (aşağıda). Buraya konursa
// "temporal dead zone" nedeniyle uygulama açılışta hata verir.

// TCMB reeskont oranları (kısa vadeli kredi işlemleri)
export const REESKONT_FAIZ_TABLOSU = [
  { baslangic: '2002-11-14', oran: 50 },
  { baslangic: '2003-02-28', oran: 48 },
  { baslangic: '2003-04-25', oran: 44 },
  { baslangic: '2003-06-13', oran: 38 },
  { baslangic: '2003-07-16', oran: 35 },
  { baslangic: '2003-10-15', oran: 31 },
  { baslangic: '2004-01-15', oran: 26 },
  { baslangic: '2004-12-29', oran: 23 },
  { baslangic: '2005-05-09', oran: 20 },
  { baslangic: '2005-12-20', oran: 17.5 },
  { baslangic: '2006-06-20', oran: 22 },
  { baslangic: '2006-07-21', oran: 25 },
  { baslangic: '2006-10-20', oran: 23.5 },
  { baslangic: '2007-12-21', oran: 19.75 },
  { baslangic: '2008-05-16', oran: 19.25 },
  { baslangic: '2008-10-22', oran: 19.75 },
  { baslangic: '2008-11-21', oran: 19.25 },
  { baslangic: '2008-12-19', oran: 17.75 },
  { baslangic: '2009-01-16', oran: 15.75 },
  { baslangic: '2009-02-20', oran: 14.25 },
  { baslangic: '2009-03-20', oran: 13.25 },
  { baslangic: '2009-04-17', oran: 12.75 },
  { baslangic: '2009-10-16', oran: 12 },
  { baslangic: '2010-12-17', oran: 14 },
  { baslangic: '2011-08-04', oran: 15 },
  { baslangic: '2011-12-21', oran: 17 },
  { baslangic: '2012-02-21', oran: 16 },
  { baslangic: '2012-09-18', oran: 13.5 },
  { baslangic: '2013-05-16', oran: 13.75 },
  { baslangic: '2014-01-29', oran: 15.5 },
  { baslangic: '2014-05-23', oran: 14.75 },
  { baslangic: '2019-07-26', oran: 19.5 },
  { baslangic: '2019-09-13', oran: 16.75 },
  { baslangic: '2019-10-25', oran: 14.75 },
  { baslangic: '2019-12-13', oran: 12.75 },
  { baslangic: '2020-05-22', oran: 10.75 },
  { baslangic: '2021-03-19', oran: 17 },
  { baslangic: '2021-09-24', oran: 16 },
  { baslangic: '2021-10-22', oran: 14 },
  { baslangic: '2021-12-17', oran: 14.75 },
  { baslangic: '2023-06-23', oran: 25.75 },
  { baslangic: '2023-07-21', oran: 27.75 },
  { baslangic: '2023-08-25', oran: 35.75 },
  { baslangic: '2023-09-22', oran: 40 },
  { baslangic: '2023-10-27', oran: 40.75 },
  { baslangic: '2023-11-24', oran: 42.5 },
  { baslangic: '2023-12-22', oran: 43.25 },
  { baslangic: '2024-04-01', oran: 50.75 },
  { baslangic: '2024-12-28', oran: 48.25 },
  { baslangic: '2025-03-08', oran: 43.25 },
  { baslangic: '2025-09-17', oran: 41.25 },
  { baslangic: '2025-12-20', oran: 38.75 },
].map((r) => ({ oran: r.oran, baslangic: new Date(r.baslangic + 'T00:00:00Z') }));

// TCMB avans oranları (ticari temerrüt / 3095 m.2/2)
export const AVANS_FAIZ_TABLOSU = [
  { baslangic: '2002-11-14', oran: 55 },
  { baslangic: '2003-02-28', oran: 53 },
  { baslangic: '2003-04-25', oran: 49 },
  { baslangic: '2003-06-13', oran: 43 },
  { baslangic: '2003-07-16', oran: 40 },
  { baslangic: '2003-10-15', oran: 36 },
  { baslangic: '2004-01-15', oran: 31 },
  { baslangic: '2004-12-29', oran: 28 },
  { baslangic: '2005-05-09', oran: 25 },
  { baslangic: '2005-12-20', oran: 22.5 },
  { baslangic: '2006-06-20', oran: 27 },
  { baslangic: '2006-07-21', oran: 30 },
  { baslangic: '2006-10-20', oran: 28.5 },
  { baslangic: '2007-12-21', oran: 24.75 },
  { baslangic: '2008-05-16', oran: 24.25 },
  { baslangic: '2008-10-22', oran: 24.75 },
  { baslangic: '2008-11-21', oran: 24.25 },
  { baslangic: '2008-12-19', oran: 22.75 },
  { baslangic: '2009-01-16', oran: 20.75 },
  { baslangic: '2009-02-20', oran: 19.25 },
  { baslangic: '2009-03-20', oran: 18.25 },
  { baslangic: '2009-04-17', oran: 17.75 },
  { baslangic: '2009-10-16', oran: 17 },
  { baslangic: '2010-12-17', oran: 19 },
  { baslangic: '2011-08-04', oran: 20 },
  { baslangic: '2011-12-21', oran: 22 },
  { baslangic: '2012-02-21', oran: 21 },
  { baslangic: '2012-09-18', oran: 18.5 },
  { baslangic: '2013-05-16', oran: 18.75 },
  { baslangic: '2014-01-29', oran: 16.5 },
  { baslangic: '2014-05-23', oran: 15.75 },
  { baslangic: '2019-07-26', oran: 20.5 },
  { baslangic: '2019-09-13', oran: 17.75 },
  { baslangic: '2019-10-25', oran: 15.75 },
  { baslangic: '2019-12-13', oran: 13.75 },
  { baslangic: '2020-05-22', oran: 11.75 },
  { baslangic: '2021-03-19', oran: 18 },
  { baslangic: '2021-09-24', oran: 17 },
  { baslangic: '2021-10-22', oran: 15 },
  { baslangic: '2021-12-17', oran: 15.75 },
  { baslangic: '2023-06-23', oran: 26.75 },
  { baslangic: '2023-07-21', oran: 28.75 },
  { baslangic: '2023-08-25', oran: 36.75 },
  { baslangic: '2023-09-22', oran: 41 },
  { baslangic: '2023-10-27', oran: 41.75 },
  { baslangic: '2023-11-24', oran: 43.5 },
  { baslangic: '2023-12-22', oran: 44.25 },
  { baslangic: '2024-04-01', oran: 51.75 },
  { baslangic: '2024-12-28', oran: 49.25 },
  { baslangic: '2025-03-08', oran: 44.25 },
  { baslangic: '2025-09-17', oran: 42.25 },
  { baslangic: '2025-12-20', oran: 39.75 },
].map((r) => ({ oran: r.oran, baslangic: new Date(r.baslangic + 'T00:00:00Z') }));

export const FAIZ_TURLERI = [
  { id: 'adiKanuni', label: 'Adi Kanuni Faiz', tablo: 'yasal' },
  // HATA DÜZELTMESİ (2026-09-03): "Avans Faizi" REESKONT tablosuna
  // bağlıydı. TCMB bu iki oranı ayrı yayımlar ve avans, reeskontun
  // her dönemde tam 1 puan üstündedir (örn. 20.12.2025: reeskont
  // %38,75 / avans %39,75). Bu yüzden hesaplar başka hesaplayıcılarla
  // tutmuyordu. Avans faizi artık AVANS tablosunu kullanır.
  { id: 'avans', label: 'Avans Faizi', tablo: 'avans' },
  // KALDIRILDI (2026-09-03): "Bankalarca İşletme Kredilerine Uygulanan
  // Azami Faiz" ve "Bankalarca Vadeli Mevduata Uygulanan Azami Faiz"
  // seçenekleri sırasıyla avans ve reeskont tablosuna bağlıydı. TCMB
  // bunlar için AYRI azami oranlar yayımlar; bu tablolar onların yerine
  // geçmez, yani iki seçenek de etiketinin vaat ettiği sonucu vermiyordu.
  // Kullanılmadıkları için yanlış sonuç üretmelerindense kaldırıldılar.
  // Gerekirse doğru TCMB serileri eklenip geri getirilebilir.
  { id: 'reeskont', label: 'Reeskont Faizi', tablo: 'reeskont' },
  { id: 'temerrut', label: 'Temerrüt Faizi', tablo: 'yasal' },
  { id: 'ticariTemerrut', label: 'Ticari Temerrüt Faizi', tablo: 'avans' },
  { id: 'tufe', label: 'TÜİK Tüketici Fiyat Endeksi (TÜFE)', tablo: null },
  { id: 'yiufe', label: 'TÜİK Yurt İçi Üretici Fiyat Endeksi (Yİ-ÜFE)', tablo: null },
];

// Tarihsel sabit dilimler + yeni rejimde reeskonttan türetilen dilimler.
// Ufuk: içinde bulunulan yıl + 1 (reeskont tablosunun izin verdiği kadar).
// REESKONT_FAIZ_TABLOSU tanımlandıktan SONRA oluşturulmalıdır.
export const YASAL_FAIZ_TABLOSU = [
  ...YASAL_FAIZ_TARIHSEL,
  // Ufuk bilerek "içinde bulunulan yıl" ile sınırlı: gelecek yılı da
  // üretmek, reeskont tablosu güncellenmediğinde eski bir orandan
  // SESSİZCE yanlış bir yıl uydurmak anlamına gelirdi.
  ...uretYasalFaizDonemleri(new Date().getUTCFullYear()),
].sort((a, b) => a.baslangic - b.baslangic);

/**
 * Reeskont tablosunun tazeliği. Kanuni faiz artık bu tablodan
 * türetildiği için tablo eskirse yasal faiz de sessizce eskir.
 * Ekranlar bununla kullanıcıyı uyarabilir.
 */
export function reeskontTablosuDurumu(bugun = new Date()) {
  const son = REESKONT_FAIZ_TABLOSU[REESKONT_FAIZ_TABLOSU.length - 1];
  if (!son) return { sonKayit: null, gunGecti: Infinity, eskimis: true };
  const gunGecti = Math.floor((bugun.getTime() - son.baslangic.getTime()) / MS_GUN);
  return {
    sonKayit: son.baslangic.toISOString().slice(0, 10),
    sonOran: son.oran,
    gunGecti,
    // TCMB oranı yılda birkaç kez değiştirir; 400 günü aşmışsa
    // büyük olasılıkla tabloya eklenmemiş bir değişiklik vardır.
    eskimis: gunGecti > 400,
  };
}

const TABLO_MAP = {
  yasal: YASAL_FAIZ_TABLOSU,
  avans: AVANS_FAIZ_TABLOSU,
  reeskont: REESKONT_FAIZ_TABLOSU,
};

const isoFromUtc = (d) => {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const g = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${g}`;
};

const addUtcDays = (d, days) => new Date(d.getTime() + days * MS_GUN);

const MS_GUN = 24 * 60 * 60 * 1000;

export const toUTCDate = (str) => {
  if (!str) return null;
  if (str instanceof Date) {
    return Number.isNaN(str.getTime()) ? null : new Date(Date.UTC(str.getUTCFullYear(), str.getUTCMonth(), str.getUTCDate()));
  }
  // "2026-07-28" veya "2026-07-28T..." formatlarını destekle
  const onlyDate = String(str).split('T')[0];
  const d = new Date(onlyDate + 'T00:00:00Z');
  return Number.isNaN(d.getTime()) ? null : d;
};

// Bugünün tarihini "YYYY-MM-DD" olarak döndür (İstanbul — canlı faiz hesabı)
export const bugunISO = () => {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  } catch {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const g = String(now.getDate()).padStart(2, '0');
    return `${y}-${m}-${g}`;
  }
};

export const hesaplaDonemliFaiz = (anapara, baslangicStr, bitisStr, tablo) => {
  const bas = toUTCDate(baslangicStr);
  const bit = toUTCDate(bitisStr);
  const rates = tablo || YASAL_FAIZ_TABLOSU;
  if (!anapara || anapara <= 0 || !bas || !bit || bit <= bas) {
    return { faiz: 0, segmentler: [], toplamGun: 0 };
  }

  let faiz = 0;
  let toplamGun = 0;
  const segmentler = [];

  for (let i = 0; i < rates.length; i++) {
    const donemBas = rates[i].baslangic;
    const donemBit =
      i < rates.length - 1
        ? rates[i + 1].baslangic
        : new Date('2999-01-01T00:00:00Z');

    const kesisimBas = new Date(Math.max(bas.getTime(), donemBas.getTime()));
    const kesisimBit = new Date(Math.min(bit.getTime(), donemBit.getTime()));
    const gun = Math.round((kesisimBit.getTime() - kesisimBas.getTime()) / MS_GUN);

    if (gun > 0) {
      const oran = rates[i].oran;
      const oranPay = (oran / 100) * (gun / 365) * 100;
      const segFaiz = anapara * (oran / 100) * (gun / 365);
      faiz += segFaiz;
      toplamGun += gun;
      const bitisDahil = addUtcDays(kesisimBit, -1);
      const isLast = kesisimBit.getTime() === bit.getTime();
      segmentler.push({
        oran,
        gun,
        faiz: segFaiz,
        oranPay,
        baslangic: isoFromUtc(kesisimBas),
        bitisExclusive: isoFromUtc(kesisimBit),
        bitisDahil: isoFromUtc(bitisDahil),
        bitisDahilMi: !isLast,
      });
    }
  }

  return { faiz, segmentler, toplamGun };
};

// Dönemlere bölerek yasal faiz: anapara × oran × gün / 365
export const hesaplaYasalFaiz = (anapara, baslangicStr, bitisStr) =>
  hesaplaDonemliFaiz(anapara, baslangicStr, bitisStr, YASAL_FAIZ_TABLOSU);

export const hesaplaAvansFaiz = (anapara, baslangicStr, bitisStr) =>
  hesaplaDonemliFaiz(anapara, baslangicStr, bitisStr, AVANS_FAIZ_TABLOSU);

/** Tabloda verilen tarihte (veya tarihsizse bugün) yürürlükteki yıllık oran. */
export const getTabloOrani = (tablo, dateStr) => {
  const rates = tablo || [];
  if (!rates.length) return 0;
  const d = toUTCDate(dateStr) || toUTCDate(bugunISO());
  if (!d) return rates[rates.length - 1].oran;
  let oran = rates[0].oran;
  for (let i = 0; i < rates.length; i++) {
    if (rates[i].baslangic.getTime() <= d.getTime()) oran = rates[i].oran;
    else break;
  }
  return oran;
};

export const getGuncelAvansOrani = (dateStr) => getTabloOrani(AVANS_FAIZ_TABLOSU, dateStr);

/** Elle girilmiş oran, otomatik TCMB (reeskont veya avans) güncel oranlarından biri mi? */
export const isVarsayilanAvansOrani = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return false;
  return x === getTabloOrani(REESKONT_FAIZ_TABLOSU) || x === getTabloOrani(AVANS_FAIZ_TABLOSU);
};

export const formatYilAyGun = (baslangicStr, bitisStr) => {
  const bas = toUTCDate(baslangicStr);
  const bit = toUTCDate(bitisStr);
  if (!bas || !bit || bit <= bas) return { yil: 0, ay: 0, gun: 0, text: '0 gün' };
  let yil = bit.getUTCFullYear() - bas.getUTCFullYear();
  let ay = bit.getUTCMonth() - bas.getUTCMonth();
  let gun = bit.getUTCDate() - bas.getUTCDate();
  if (gun < 0) {
    ay -= 1;
    const prev = new Date(Date.UTC(bit.getUTCFullYear(), bit.getUTCMonth(), 0));
    gun += prev.getUTCDate();
  }
  if (ay < 0) {
    yil -= 1;
    ay += 12;
  }
  const parts = [];
  if (yil) parts.push(`${yil} yıl`);
  if (ay) parts.push(`${ay} ay`);
  if (gun || parts.length === 0) parts.push(`${gun} gün`);
  return { yil, ay, gun, text: parts.join(' ') };
};

/**
 * HATA DÜZELTMESİ (2026-09-03): Yalnızca nokta içeren girdiler
 * ("1.250.000" gibi) hiçbir dala girmiyordu ve parseFloat bunu 1,25
 * olarak okuyordu — yani tutar bir milyon kat küçülüyordu. Türkçe
 * yazımda nokta grupları tam 3 haneliyse binlik ayracıdır.
 */
export const parseTRAmount = (value) => {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  let s = String(value).trim().replace(/\s/g, '');
  if (!s) return 0;

  const negatif = s.startsWith('-');
  if (negatif) s = s.slice(1);

  if (s.includes(',')) {
    // Virgül ondalıktır; noktalar binlik ayracıdır.
    s = s.replace(/\./g, '').replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
    // Sadece nokta var ve tüm gruplar 3 haneli -> binlik ayracı
    s = s.replace(/\./g, '');
  }
  // Aksi halde nokta ondalık kabul edilir ("1.25")

  const n = parseFloat(s);
  if (!Number.isFinite(n)) return 0;
  return negatif ? -n : n;
};

export const formatFaizTR = (n, digits = 2) =>
  (Number(n) || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export const formatDateTR = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
};

export const hesaplaYasalFaizAraci = (anaparaInput, baslangicStr, bitisStr, turId = 'adiKanuni') => {
  const tur = FAIZ_TURLERI.find((t) => t.id === turId) || FAIZ_TURLERI[0];
  if (!tur.tablo) {
    return { unsupported: true, tur };
  }
  const anapara = parseTRAmount(anaparaInput);
  const ham = hesaplaDonemliFaiz(anapara, baslangicStr, bitisStr, TABLO_MAP[tur.tablo]);
  const sure = formatYilAyGun(baslangicStr, bitisStr);
  const gerceklesenOran = anapara > 0 ? (ham.faiz / anapara) * 100 : 0;
  return {
    unsupported: false,
    tur,
    anapara,
    ...ham,
    sure,
    gerceklesenOran,
    toplam: anapara + ham.faiz,
  };
};

// Sabit yıllık oranla faiz (avans / sözleşme faizi): anapara × oran × gün / 365
export const hesaplaSabitFaiz = (anapara, baslangicStr, bitisStr, yillikOran) => {
  const bas = toUTCDate(baslangicStr);
  const bit = toUTCDate(bitisStr);
  const oran = Number(yillikOran) || 0;
  if (!anapara || anapara <= 0 || !bas || !bit || bit <= bas || oran <= 0) {
    return { faiz: 0, segmentler: [], toplamGun: 0 };
  }
  const gun = Math.round((bit.getTime() - bas.getTime()) / MS_GUN);
  const faiz = anapara * (oran / 100) * (gun / 365);
  return { faiz, segmentler: [{ oran, gun, faiz }], toplamGun: gun };
};

// Faiz türüne göre dağıtıcı: 'Yasal' | 'Avans' | 'Sozlesme'
// Avans: varsayılan TCMB dönemsel tablo; oranManuel ise tek sabit oran.
export const hesaplaFaiz = (anapara, baslangicStr, bitisStr, faizTuru, yillikOran, oranManuel = false) => {
  if (faizTuru === 'Yasal' || !faizTuru) {
    return hesaplaYasalFaiz(anapara, baslangicStr, bitisStr);
  }
  if (faizTuru === 'Avans' && !oranManuel) {
    return hesaplaAvansFaiz(anapara, baslangicStr, bitisStr);
  }
  return hesaplaSabitFaiz(anapara, baslangicStr, bitisStr, yillikOran);
};
